import type { StepType } from "@reactour/tour";
import TourStepContent from "../../wrapper";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";
import { text, translateJadleToLocale } from "@quickpoint.me/shared";

const t = () => text.tourSteps;

const firstSlide: StepType[] = [
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => <span>{text.tourSteps.teacherWhereYouType}</span>}
			/>
		),
		position: "left",
		action: () => {
			fireClearCodeEvent();
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsTypePrefix} <strong>title:</strong> {text.tourSteps.teacherTypeTitleSuffix}
					</span>
				)}
			/>
		),
		position: "left",
		action: () => {
			typeSomeText({ text: translateJadleToLocale(`title: ${t().teacherFirstTitle}`) });
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => <span>{text.tourSteps.teacherTitleAppears}</span>}
			/>
		),
		position: "left",
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.teacherFirstSlide}
						<br />
						<br />
						{text.tourSteps.teacherAddParagraph}
					</span>
				)}
			/>
		),
		position: "center",
		action: () => {
			typeSomeText({ text: `\n${t().teacherFirstParagraph}` });
		},
	},
];

export default firstSlide;
